import { FormStylesData } from './form-styles-data';

export function formStylesDataToCssVariables(styles: FormStylesData): string {
    const vars: string[] = [];
    for (const [key, value] of Object.entries(styles)) {
        if (value != null && value !== '') {
            const cssVar = '--_tfb-' + key.replace(/([A-Z])/g, '-$1').toLowerCase();
            vars.push(`    ${cssVar}: ${value};`);
        }
    }
    return vars.length > 0 ? `:host {\n${vars.join('\n')}\n}` : '';
}
